import React, { useCallback, useRef, useState } from 'react';
import './Videos.css';

const videos = [
  { id: '1', title: 'Casamientos', url: '/videos/video1.MP4' },
  { id: '2', title: 'Traslado Escolar', url: '/videos/video2.MP4' },
  { id: '3', title: 'Vacaciones', url: '/videos/video3.MP4' },
  { id: '4', title: 'Turismo', url: '/videos/video4.MP4' },
  { id: '5', title: 'Deportes', url: '/videos/video5.MP4' },
  { id: '6', title: 'Deportes', url: '/videos/video6.MP4' },
  { id: '7', title: 'Deportes', url: '/videos/video7.MP4' },
  { id: '8', title: 'Deportes', url: '/videos/video8.MP4' },
];

export default function Video() {
  const [playingId, setPlayingId] = useState(null);
  const videoRefs = useRef({});
  const requestedPlayIdRef = useRef(null);

  const togglePlayback = useCallback((id) => {
    const selectedVideo = videoRefs.current[id];

    if (!selectedVideo) {
      return;
    }

    if (!selectedVideo.paused) {
      selectedVideo.pause();
      requestedPlayIdRef.current = null;
      setPlayingId(null);
      return;
    }

    Object.entries(videoRefs.current).forEach(([videoId, videoElement]) => {
      if (videoId !== id) {
        videoElement.pause();
      }
    });

    if (selectedVideo.ended) {
      selectedVideo.currentTime = 0;
    }

    selectedVideo.muted = false;
    selectedVideo.volume = 1;
    requestedPlayIdRef.current = id;
    selectedVideo
      .play()
      .then(() => {
        if (requestedPlayIdRef.current === id) {
          setPlayingId(id);
        }
      })
      .catch(() => {
        if (requestedPlayIdRef.current === id) {
          requestedPlayIdRef.current = null;
          setPlayingId(null);
        }
      });
  }, []);

  const syncStoppedVideo = useCallback((id) => {
    if (requestedPlayIdRef.current === id) {
      requestedPlayIdRef.current = null;
    }

    setPlayingId((currentId) => (currentId === id ? null : currentId));
  }, []);

  const handleVideoPlay = useCallback((id) => {
    setPlayingId(id);
  }, []);

  const handleKeyDown = (event, id) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      togglePlayback(id);
    }
  };

  return (
    <div className="video-gallery">
      <div className="titleDestinos" id="Destinos">
        <span>NUESTROS</span> <span className="preferidos">VIAJES</span>
      </div>
      <div className="video-grid">
        {videos.map((video) => {
          const isPlaying = playingId === video.id;

          return (
            <div
              key={video.id}
              className={`video-card${isPlaying ? ' video-card--playing' : ''}`}
              onClick={() => togglePlayback(video.id)}
              onKeyDown={(event) => handleKeyDown(event, video.id)}
              role="button"
              tabIndex={0}
              aria-label={`${isPlaying ? 'Pausar' : 'Reproducir'} video de ${video.title}`}
            >
              <div className="video-wrapper">
                <video
                  ref={(el) => {
                    if (el) {
                      videoRefs.current[video.id] = el;
                    } else {
                      delete videoRefs.current[video.id];
                    }
                  }}
                  src={video.url}
                  playsInline
                  preload="metadata"
                  controls={isPlaying}
                  onPlay={() => handleVideoPlay(video.id)}
                  onPause={() => syncStoppedVideo(video.id)}
                  onEnded={() => syncStoppedVideo(video.id)}
                />
                <div className="video-overlay" aria-hidden="true">
                  <span className="video-play-btn" />
                </div>
              </div>
              <p className="video-title">{video.title}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
